/**
 * Rate the same headcount would pay if every guest were an adult - the ceiling for the
 * children charge. Returns null (no ceiling, callers skip the cap) when the rate plan holds
 * no value for that occupancy or unitTypeOccupancy is missing.
 *
 * @param {object} ratePlan
 * @param {object} unitTypeOccupancy
 * @param {number} adults
 * @param {array} childrenAges every child counts as a person, regardless of how it is charged
 * @param {string} rateKey totalRate, totalRateBeforeDiscount or firstNightBasePrice
 */
const getAllAdultsRate = (ratePlan, unitTypeOccupancy, adults, childrenAges, rateKey = 'totalRate') => {
  const persons = (adults || 0) + (childrenAges ? childrenAges.length : 0)

  if (!persons) {
    return null
  }

  const paxValue = ratePlan.paxValues && ratePlan.paxValues.find(value => value.pax === persons)

  if (paxValue) {
    return paxValue[rateKey]
  }

  // pax row missing - at standard occupancy the rate plan itself carries the price
  if (unitTypeOccupancy && persons === unitTypeOccupancy.standardOccupancy) {
    return ratePlan[rateKey]
  }

  return null
}

/**
 * Children charge trimmed so that adults rate + children charge never exceeds what the same
 * number of adults would pay.
 */
export const capChildrenPrice = (childrenPrice, adultsRate, allAdultsRate) => {
  if (allAdultsRate === null || allAdultsRate === undefined) {
    return childrenPrice
  }

  return Math.min(childrenPrice, Math.max(0, allAdultsRate - adultsRate))
}

export default getAllAdultsRate
